/**
 * Skeleton component
 * This serves as placeholder whilst the data is loading
 * @author Carlos López Rodriguez <clopez@adasasistemas.com>
 */

import { Skeleton } from '@components/general';
import { FormLabels } from '@utils';

// Styles
import styles from './formSkeleton.module.scss';

export const FormSkeleton = <T,>({ labels }: { labels: FormLabels<T> }) => {
	const getLabelValueByKey = (labelKey: string) => {
		return labels[labelKey as keyof FormLabels<T>];
	};

	return (
		<div className="form--grid">
			{Object.keys(labels)
				.map(labelKey => getLabelValueByKey(labelKey))
				.filter(labelValue => labelValue.length > 0)
				.map(labelValue => (
					<>
						<label>{labelValue}:</label>
						<Skeleton customStyles={styles['skeleton--field']} />
						<p></p>
					</>
				))}
		</div>
	);
};
